// removed by extract-text-webpack-plugin
module.exports = {"modal__body":"ModalCheckout-module__modal__body___1QmTh","modal__title":"ModalCheckout-module__modal__title___3okOY","error":"ModalCheckout-module__error___1nRF2","modal__content":"ModalCheckout-module__modal__content___dkZ8u","modal__link":"ModalCheckout-module__modal__link___2pCIR","modal__action":"ModalCheckout-module__modal__action___17hTW"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/ModalCheckout/ModalCheckout.module.css
// module id = 636
// module chunks = 0